import useResponsive from './useResponsive';
import usePrefersHoverDesktop from './usePrefersHoverDesktop';
import { resolveLayoutMode, type LayoutMode } from '../constants/layoutBreakpoints';

const useLayoutMode = (): LayoutMode => {
  const { windowWidth } = useResponsive();
  const prefersHoverDesktop = usePrefersHoverDesktop();

  return resolveLayoutMode(windowWidth, { prefersHoverDesktop });
};

export default useLayoutMode;
